// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__3iZc2","panel--raised":"Panel_panel--raised__5GI4J"};